
import React from 'react';

export const UploadIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    upload_file
  </span>
);
